import AddCommentIcon from "@mui/icons-material/AddComment";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import BakeryDiningIcon from "@mui/icons-material/BakeryDining";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import LiquorIcon from "@mui/icons-material/Liquor";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import PetsIcon from "@mui/icons-material/Pets";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SportsBarIcon from "@mui/icons-material/SportsBar";
import StoreIcon from "@mui/icons-material/Store";
import TireRepairIcon from "@mui/icons-material/TireRepair";
import type { BranchItemProps } from "./BranchItem/types/BranchItemProps";

export const branchesData: BranchItemProps[] = [
  { name: "Autopeças e Mecânica", icon: DirectionsCarIcon },
  { name: "Implementos Agrícolas", icon: AgricultureIcon },
  { name: "Lojas de Conveniência", icon: StoreIcon },
  { name: "Farmácias", icon: LocalPharmacyIcon },
  { name: "Depósitos de Gás", icon: LocalGasStationIcon },
  { name: "Distribuidoras de Bebidas", icon: LiquorIcon },
  { name: "Padarias", icon: BakeryDiningIcon },
  { name: "Restaurantes/Lanchonetes", icon: RestaurantIcon },
  { name: "Perfumarias", icon: DryCleaningIcon },
  { name: "Petshops", icon: PetsIcon },
  { name: "Bares", icon: SportsBarIcon },
  { name: "Revendedoras de Pneus e Vidros Automotivos", icon: TireRepairIcon },
  { name: "Lojas de Materiais Elétricos", icon: ElectricalServicesIcon },
  { name: "E outras mais...", icon: AddCommentIcon },
];
